<template>
<div>
<main>

 <section class="blue-box">

            <div class="flex-group align-end">
                <div class="text">
                    <h1>Impressum</h1>
                    <p>
                    Sabine Döbrössy BSc<br />
                    Pielachstraße 6<br />
                    AT - 3382 Albrechtsberg an der Pielach
                    </p>
                    <p>Mobil: <a href="tel:+436503614224">0650 / 36 14 224</a></p>
                    <p>Email: <a href="mailto:info@pferdeverstand.at?subject=Anfrage%20Pferdeverstand.at">info@pferdeverstand.at</a></p>
                    <p>Pferde- und Reittrainer</p>
                    <p>UID-Nr: ATU 69615446</p>
                </div>

                <div class="text">

                    <p>
                    Bezirkshauptmannschaft Melk
                    </p>
                    <p>
                    Verbraucher haben die M&ouml;glichkeit, Beschwerden an die OnlineStreitbeilegungsplattform der EU zu richten:
                    <a href="http://ec.europa.eu/odr">http://ec.europa.eu/odr</a>
                    </p>
                    <p>
                    Sie k&ouml;nnen allf&auml;llige Beschwerden auch an die angegebene E-Mail-Adresse richten.
                    </p>

                    <h1>Fotocredits</h1>
                    <p>Besten Dank an <a href="https://maxberg.at/fotografie">Max Berg</a> für die tollen Aufnahmen.</p>
                </div>
            </div>

</section>


</main>
</div>
</template>


<script>
export default {
  name: "Impressum",
   metaInfo() {
        return { 
            title: "Pferdeverstand.at - Sabine Döbrössy",
            meta: [
                { name: 'description', content:  'Impressum, Kontakt, Adresse, Telefonummer, Email'},
                { property: 'og:title', content: "Impressum - Pferdeverstand.at"},                
                { property: 'og:description', content: "Sabine Döbrössy, info@pferdeverstand.at, Pielachstraße 6, 3382 Albrechtsberg an der Pielach'"},
              { property: 'og:image', content: '../assets/img/og/pferdeverstand-logo.png'},
                { property: 'og:url', content: 'www.pferdeverstand.at/impressum'}
            ]
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Impressum.vue